<template>
  <div style="height: 40px">
    <v-autocomplete
      v-model="friends"
      :disabled="isUpdating"
      :items="items"
      dense
      chips
      small-chips
      color="#000000"
      background-color="#ffffff"
      style="border-radius: 30px"
      multiple
      solo
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "AutoComplete",
  data() {
    return {
      friends: "",
      isUpdating: false,
      items: ["foo", "bar", "fizz", "buzz"]
    };
  }
};
</script>

<style scoped></style>
